import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import 'normalize.css';
import './document.css';
import './globalStyle.css';
import './globalTheme.css';

// Add Font Awesome styles directly, so they can be server-rendered
// Prevent Font Awesome from adding styles client-side again
config.autoAddCss = false;
